import Button from "@material-ui/core/Button";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { handleChangeEvent, handlePatch } from "../../../../utils/AxiosUtil";
import * as enums from "../../../../utils/EnumMapping";
import { toDateFormat, trimSpaces } from "../../../../utils/Util";
import ErrorAwareAmountField from "../../../common/inputfields/ErrorAwareAmountField";
import ErrorAwareDatePicker from "../../../common/inputfields/ErrorAwareDatePicker";
import ErrorAwareSelectField from "../../../common/inputfields/ErrorAwareSelectField";
import ErrorAwareTextField from "../../../common/inputfields/ErrorAwareTextField";
import MyAutocomplete from "../../../common/inputfields/MyAutocomplete";
import PaymentMethodFormControl from "../../../common/inputfields/PaymentMethodFormControl";
import * as util from "./IncomingBillUtil";

class ModifyIncoming extends Component {
  componentDidMount() {
    console.log(this.props);
  }

  fields = util.fields;
  state = {
    selectedCurrency: this.props.row.currency,
    selectedPaymentMethod: enums.getObjectByValue(
      enums.paymentMethods,
      this.props.row.paymentMethod
    ),
    selectedType: enums.getObjectByValue(enums.billTypes, this.props.row.type),
    selectedCustomer: {
      value: this.props.row.customerId,
      label: this.props.row.customerName,
    },
    prevCustomer: {
      value: this.props.row.customerId,
      label: this.props.row.customerName,
    },
    selectedCategory: {
      value: this.props.row.categoryId,
      label: this.props.row.categoryName,
    },
    prevCategory: {
      value: this.props.row.categoryId,
      label: this.props.row.categoryName,
    },

    billDate: new Date(this.props.row.billDate),
    fulfillmentDate: new Date(this.props.row.fulfillmentDate),
    paymentDeadline: new Date(this.props.row.paymentDeadline),

    vat: this.props.row.vat,
    amount: this.props.row.amount,

    billNumber: this.props.row.billNumber,
    comment: this.props.row.comment,

    hideLinkBillComponent: true,
    customerRelatedDropDown: true,
    errors: new Map(),
  };

  handleSubmit = async (event) => {
    event.persist();
    event.preventDefault();
    const path = "/api/incomingbill";
    const requestObject = {
      publicId:
        this.state.selectedLinkBill && this.state.selectedLinkBill.value
          ? this.state.selectedLinkBill.value
          : this.props.row.publicId,
      privateId: this.props.row.privateId,
      paymentMethod: this.state.selectedPaymentMethod.value,
      customerId: this.state.selectedCustomer.value,
      categoryId: this.state.selectedCategory.value,
      type: this.state.selectedType.value,

      billDate: toDateFormat(this.state.billDate),
      fulfillmentDate: toDateFormat(this.state.fulfillmentDate),
      paymentDeadline: toDateFormat(this.state.paymentDeadline),

      vat: trimSpaces(this.state.vat),
      amount: trimSpaces(this.state.amount),

      billNumber: this.state.billNumber,
      comment: this.state.comment,
    };
    console.log(requestObject);
    handlePatch(path, requestObject, this);
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="flex-form">
          <div className="input-group">
            <PaymentMethodFormControl
              options={enums.paymentMethods}
              value={this.state.selectedPaymentMethod}
              prevValue={enums.getObjectByValue(
                enums.paymentMethods,
                this.props.row.paymentMethod
              )}
              onChange={(event) => util.handlePaymentMethodChange(event, this)}
            />
          </div>
          <div className="input-group">
            <MyAutocomplete
              value={this.state.selectedCustomer}
              prevValue={this.state.prevCustomer}
              getOptions={util.promiseCustomerOptions}
              onChange={(e, v) => util.handleCustomerSelected(e, v, this)}
              label={"Megnevezés"}
              createLabel={"Új beszállító"}
            />
          </div>
          <div className="input-group">
            <ErrorAwareDatePicker
              required
              id="bill-date"
              name="billDate"
              label="Számla kelte"
              errors={this.state.errors}
              value={this.state.billDate}
              prevValue={this.props.row.billDate}
              onChange={(value) => util.handleBillDateChange(value, this)}
            />
          </div>
          <div className="input-group">
            <ErrorAwareDatePicker
              required
              id="fullfillment-date"
              name="fullFillmentDate"
              label="Teljesítés kelte"
              errors={this.state.errors}
              value={this.state.fulfillmentDate}
              prevValue={this.props.row.fulfillmentDate}
              onChange={(value) =>
                util.handleFulfillmentDateChange(value, this)
              }
            />
          </div>
          <div className="input-group">
            <ErrorAwareTextField
              required
              name="billNumber"
              id="bill-number"
              label="Számlaszám"
              errors={this.state.errors}
              value={this.state.billNumber}
              prevValue={this.props.row.billNumber}
              onChange={(e) => handleChangeEvent(e, this)}
            />
          </div>
          <div className="input-group">
            <ErrorAwareDatePicker
              required
              id="payment-deadline-date"
              name="paymentDeadline"
              label="Fizetési határidő"
              errors={this.state.errors}
              value={this.state.paymentDeadline}
              prevValue={this.props.row.paymentDeadline}
              onChange={(value) =>
                util.handlePaymentDeadlineChange(value, this)
              }
            />
          </div>
          <div className="input-group">
            <ErrorAwareAmountField
              required
              id="amount"
              name="amount"
              label="Bruttó összeg"
              pattern="[0-9]*"
              value={this.state.amount}
              errors={this.state.errors}
              prevValue={this.props.row.amount}
              onChange={(e) => handleChangeEvent(e, this)}
            />
          </div>
          <div className="input-group">
            <ErrorAwareAmountField
              required
              id="vat"
              name="vat"
              label="Áfa összege"
              pattern="[0-9]*"
              value={this.state.vat}
              errors={this.state.errors}
              prevValue={this.props.row.vat}
              onChange={(e) => handleChangeEvent(e, this)}
            />
          </div>
          <div className="input-group">
            <ErrorAwareTextField
              name="comment"
              label="Megjegyzés"
              errors={this.state.errors}
              value={this.state.comment}
              prevValue={this.props.row.comment}
              // modify={true}
              onChange={(e) => handleChangeEvent(e, this)}
              inputProps={{ maxLength: 5000 }}
            />
            <div style={{ textAlign: 'right', fontSize: '0.75rem', color: '#666', marginTop: '2px' }}>
              {(this.state.comment || '').length} / 5000
            </div>
          </div>
          <div className="input-group">
            <MyAutocomplete
              value={this.state.selectedCategory}
              prevValue={this.state.prevCategory}
              getOptions={util.promiseCategoryOptions}
              onChange={(e, v) => util.handleCategorySelected(e, v, this)}
              label={"Költségviselő"}
              createLabel={"Új költségviselő"}
            />
          </div>
          <div className="input-group">
            <ErrorAwareSelectField
              labelId="type-label"
              id="type-label"
              name="selectedType"
              label="Számla típusa"
              errors={this.state.errors}
              value={this.state.selectedType}
              prevValue={enums.getObjectByValue(
                enums.billTypes,
                this.props.row.type
              )}
              onChange={(e) => util.handleBillTypeChange(e, this)}
              options={enums.billTypes}
            />
          </div>
          <div className="input-group">
            <MyAutocomplete
              value={this.state.selectedLinkBill}
              getOptions={() => util.promiseLinkBillOptions(this)}
              onChange={(e, v) => util.handleLinkBillSelected(e, v, this)}
              hidden={this.state.hideLinkBillComponent}
              label={"Linkelt számla"}
              renderOption={(option, { selected }) => (
                <div className="ittttttt">
                  {console.log(option)}
                  {option.label}
                </div>
              )}
            />
          </div>
          {/*<div className='input-group'>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel id="currency-label">Pénznem</InputLabel>
                                <Select
                                    labelId="currency-label"
                                    id="currency"
                                    value={this.state.selectedCurrency}
                                    onChange={(event) => this.setState({ selectedCurrency: event.target.value })}
                                    label="Pénznem"
                                    disabled={true}>
                                    {enums.currencies.map((value, index) =>
                                        <MenuItem key={index} value={value}>{value.label}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                                    </div>*/}
        </div>
        <div className="form-actions">
          <Button
            className="btn-submit"
            variant="contained"
            color="primary"
            type="submit"
          >
            {this.props.row.state === "RECEIVED" ? "Befogad" : "Módosít"}
          </Button>
        </div>
      </form>
    );
  }
}

export default withSnackbar(ModifyIncoming);
